/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkerJobDto } from '../../models/worker-job-dto';

export interface WorkerControllerClaim$Params {
}

export function workerControllerClaim(http: HttpClient, rootUrl: string, params?: WorkerControllerClaim$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkerJobDto>> {
  const rb = new RequestBuilder(rootUrl, workerControllerClaim.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkerJobDto>;
    })
  );
}

workerControllerClaim.PATH = '/worker/claim';
